import { datasource } from "./datasource";

export const dashboardDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("dashboard", {
    model: {
      id: "id",
      byProshop: true,
      fields: {
        most_recent: {
          type: "object",
        },
        range: {
          type: "object",
        },
        current_totals: {
          type: "object",
        },
        previous_totals: {
          type: "object",
        },
        popular_grips: {
          type: "array",
        },
        popular_balls: {
          type: "array",
        },
        charts: {
          type: "object",
        },
      },
    },
  });
